module.exports = __webpack_public_path__ + "static/media/bonusSpins_250_500.9dcca743.png";